import React from 'react';
import { FadeIn } from './Shared';
import { Gift } from 'lucide-react';
export const BonusesTable = () => {
  const bonuses = [{
    num: '01',
    name: 'Mapa Rápido de Rutinas por Edad',
    value: '$8.000'
  }, {
    num: '02',
    name: 'Checklist Nocturno Anti-Caos',
    value: '$8.000'
  }, {
    num: '03',
    name: 'Guía Express de Señales de Cansancio Real',
    value: '$9.000'
  }, {
    num: '04',
    name: 'Planilla de Seguimiento 7 Días',
    value: '$8.000'
  }, {
    num: '05',
    name: 'Mini Guía de Noches Difíciles Sin Improvisar',
    value: '$9.000'
  }];
  return <section className="py-8 md:py-12 px-4 bg-navy-900" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-center mb-8" data-id="element-18">
            <h2 className="text-xl md:text-3xl font-serif font-bold text-white flex items-center justify-center" data-id="element-19">
              <Gift className="w-8 h-8 text-gold-400 mr-4" data-id="element-20" />
              🎁 5 BONOS INCLUIDOS — SIEMPRE GRATIS
            </h2>
          </div>

          <div className="bg-navy-800 rounded-2xl border border-navy-700 overflow-hidden shadow-2xl" data-id="element-21">
            <div className="overflow-x-auto" data-id="element-22">
              <table className="w-full text-left border-collapse" data-id="element-23">
                <thead data-id="element-24">
                  <tr className="bg-navy-900 border-b border-navy-700" data-id="element-25">
                    <th className="py-4 px-6 text-gray-400 font-medium w-16" data-id="element-26">
                      #
                    </th>
                    <th className="py-4 px-6 text-gray-400 font-medium" data-id="element-27">
                      Bono
                    </th>
                    <th className="py-4 px-6 text-gray-400 font-medium text-right" data-id="element-28">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-navy-700/50" data-id="element-29">
                  {bonuses.map((bono, index) => <tr key={index} className="hover:bg-navy-700/30 transition-colors" data-id="element-30">
                      <td className="py-4 px-6 text-gold-500 font-bold" data-id="element-31">
                        {bono.num}
                      </td>
                      <td className="py-4 px-6 text-gray-200 font-medium" data-id="element-32">
                        {bono.name}
                      </td>
                      <td className="py-4 px-6 text-right" data-id="element-33">
                        <span className="text-gray-500 line-through mr-3 text-sm" data-id="element-34">
                          {bono.value}
                        </span>
                        <span className="text-green-400 font-bold bg-green-400/10 px-2 py-1 rounded" data-id="element-35">
                          GRATIS
                        </span>
                      </td>
                    </tr>)}
                </tbody>
                <tfoot data-id="element-36">
                  <tr className="bg-navy-900/80 border-t-2 border-gold-500/30" data-id="element-37">
                    <td colSpan={2} className="py-6 px-6 text-right text-white font-bold text-lg" data-id="element-38">
                      Total bonos
                    </td>
                    <td className="py-6 px-6 text-right" data-id="element-39">
                      <span className="text-gray-500 line-through mr-3 text-sm block md:inline" data-id="element-40">
                        $42.000
                      </span>
                      <span className="text-green-400 font-bold text-xl" data-id="element-41">
                        GRATIS
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};